import {autostrategySellerService} from 'services/seller';


export const SET_AUTOSTRATEGY = 'SET_AUTOSTRATEGY';
export const FETCH_AUTOSTRATEGY_LIST = 'FETCH_AUTOSTRATEGY_LIST';

const autostrategyStore = {
  namespaced: true,
  state: {
    autostrategyList: []
  },
  getters: {
    autostrategyList (state) {
      return state.autostrategyList;
    }
  },
  mutations: {
    [SET_AUTOSTRATEGY] (state, autostrategyList) {
      state.autostrategyList = autostrategyList;
    }
  },
  actions: {
    async [FETCH_AUTOSTRATEGY_LIST] (context) {
      const projectId = context.rootGetters['sellerUser/getProjectId'];
      if (context.getters.autostrategyList.length) {
        return context.getters.autostrategyList;
      }

      const autostrategyList = await autostrategySellerService.list(projectId);
      context.commit(SET_AUTOSTRATEGY, autostrategyList);

      return autostrategyList;
    }
  }
};

export default autostrategyStore;
